import React from '../helpers/react'
import { connect } from '../helpers/composeReducer.js'
import {getHookClass} from '../helpers/cssHooks.js';
import TOC from '../components/TOC.js';
import Toolbar from '../components/Toolbar.js';
import {toggleFullscreen, onFullscreen} from '../helpers/ui.js';
import {toggleFullscreen as toggleFullscreenAction} from '../actions/ui.action.js';
import {initModel} from '../actions/model.action.js';
import classList from 'ereader-core/dist/classList';
import { ViewTypes } from '../reducers/index.js';
import {toggleTOC} from "../actions/toc.action";

export const App = React.createClass({
    componentWillMount : function(){
        this.props.initModel(this.props.params.isbn13);
    },
    componentDidMount : function(){
        document.addEventListener('mousedown',this.toggle);
        onFullscreen((is_fullscreen)=>{
            if (is_fullscreen !== this.props.is_fullscreen) {
                this.props.toggleFullscreen(is_fullscreen);
            }
        });
        this.componentDidUpdate();
    },
    componentDidUpdate : function() {
        toggleFullscreen(this.props.is_fullscreen, this.refs.tbs);
    },
    toggle : function(e) {
        const toggle_button_clicked = e.target.classList.contains('toggle-button-toolbar') || e.target.closest('.toggle-button-toolbar');
        const toc_sidebar_clicked = e.target.classList.contains('TBS_TOC') || e.target.closest('.TBS_TOC');
        const outside_player_clicked = this.refs.tbs && !this.refs.tbs.contains(e.target);
        const inside_player_clicked = !toggle_button_clicked && !toc_sidebar_clicked;
        if (this.props.toc_visible && (outside_player_clicked || inside_player_clicked) ) {
            this.props.toggleTOC();
        }
    },
    render : function render(cb) {
        let tbs_class = classList('TBSPlayer', getHookClass('App'));
        let main_class = classList('main');

        if (this.props.is_fullscreen) {
            tbs_class.push('fullscreen');
        }

        return <section ref="tbs" className={tbs_class} >
                <Toolbar params={this.props.params} />
                {(this.props.view == ViewTypes.TOP_TOOLBAR) ? '' : <TOC />}
                <section className={main_class} ref="main">
                    {this.props.children}
                </section>
            </section>
    }
});



export const mapStateToProps = function(state) {
    return {
        toc_visible : state.toc.visible,
        is_fullscreen : state.ui.is_fullscreen,
        view : state.options.view
    };
};

export default connect(mapStateToProps, {
    toggleFullscreen: toggleFullscreenAction,
    initModel,
    toggleTOC
})(App)



// WEBPACK FOOTER //
// ./src/containers/App.js